const state = {
    restTime: false,
    campaignTime: true,
    startCampaign: false,
    inCall: false,
    callData: {
        tab: null,
        tab_obs: null,
        call_id: null
    }
}

const getters = {
    getRestTime: state => state.restTime,
    getCampaignTime: state => state.campaignTime,
    getStartCampaign: state => state.startCampaign,
    getCallData: state => state.callData,
    getInCall: state => state.inCall,
}

const mutations = {
    mutationRestTime: (state, data) => {
        const tempValue = data == null ? !state.restTime : !!data;
        state.restTime = tempValue;
        state.campaignTime = !tempValue;
    },
    mutationCampaignTime: (state, data) => {
        const tempValue = data == null ? !state.campaignTime : !!data;
        state.campaignTime = tempValue;
        state.restTime = !tempValue;
    },
    mutationStartCampaign: (state) => {
        state.startCampaign = !state.startCampaign;
    },
    mutationCallData: (state, data) => {
        if (data.tab) state.callData.tab = data.tab;
        if (data.tab_obs) state.callData.tab_obs = data.tab_obs;
        if (data.call_id) state.callData.call_id = data.call_id;
    },
    mutationInCall: (state, data) => {
        state.inCall = data;
    }
}

const actions = {
    async setRestTime({ commit }, data = null) {
        commit('mutationRestTime', data);
    },
    async setCampaignTime({ commit }, data = null) {
        commit('mutationCampaignTime', data);
    },
    async setStartCampaign({ commit }) {
        commit('mutationStartCampaign');
    },
    async setCallData({ commit }, data) {
        commit('mutationCallData', data);
    },
    async setInCall({ commit }, data) {
        commit('mutationInCall', data);
    }
}

export default {
    getters,
    mutations,
    actions,
    state
}